<template>
  <Card :bordered="false" class="response-message">
    <Icon type="md-checkmark-circle" size="120" color="#19be6b" class="message-icon" />
    <!--      <h2>Successful email validation</h2><br>-->
    <h4 v-html="message"></h4>
  </Card>
</template>
<script>

  export default {
    name: "PasswordResetSuccess",
    data() {
      return {
        message:''
      };
    },
    mounted() {
      if(this.$route.query.hasOwnProperty('message')>-1){
        this.message=this.$route.query.message
      }
    }

  };
</script>
<style scoped>
</style>
